import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Plus, X, Trash2 } from "lucide-react";
import "../styles/ItemModels.css";
import { getData, postData, patchData, deleteData, getDataById } from "../api/ApiServices";
import TableComponent from "./TableComponent";
import Pagination from "../view/common/pagination/Pagination";
import CustomAlert from "../view/common/alert/CustomAlert";
import "../styles/common/sub-menu.css";
import "../styles/common/spinner.css";
import "../styles/common/icon-style.css";
import "../styles/ItemModels.css";
import "../styles/common/toplayout.css";
import "../styles/common/btn.css";
import "../styles/common/custom-alert.css";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/slices/store";
import { resetFilters, updateFilters } from "../redux/slices/filterSlice";
import { BomUtils } from "../utils/bom/bomutils";
import { Bom, Component } from '../models/bom/bom'
import BomComponentsPopup from "../view/bomComponentsPopUp";

const customStyles = `
  .form-group {
    position: relative;
    margin-bottom: 20px;
    width: 100%;
  }
  
  .form-group input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  .form-group input.input-error {
    border-color: #ff6b6b;
  }
  
  .form-error-message {
    color:rgb(255, 0, 0);
    font-size: 14px;
    margin-top: 4px;
    position: absolute;
    bottom: -18px;
    left: 0;
  }
  
  .select-container {
    margin-bottom: 20px;
    position: relative;
    z-index: 2;
  }
  
  .select-error .react-select__control {
    border-color: #ff6b6b;
  }
  
  .components-container {
    margin-top: 20px;
    border: 1px solid #eee;
    border-radius: 4px;
    padding: 15px;
  }
  
  .component-row {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
    align-items: flex-start;
  }
  
  .component-select {
    flex: 1;
  }
  
  .qty-input {
    width: 100px;
  }
  
  .remove-btn {
    background: none;
    border: none;
    color: #ff6b6b;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
  }
  
  .add-component-btn {
    background-color: #4caf50;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 8px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 10px;
  }
  
  /* Improved modal styles with reduced size */
  .item-models-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .item-models-modal {
    background-color: #fff;
    border-radius: 8px;
    width: 80%;
    max-width: 700px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }
  
  .item-models-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 10px;
    border-bottom: 1px solid #eee;
  }
  
  .item-models-modal-header h5 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
  }
  
  .item-models-modal-close {
    background: none;
    border: none;
    cursor: pointer;
    padding: 3px;
  }
  
  .modal-form-container {
    padding: 15px;
    overflow-y: auto;
    max-height: calc(80vh - 50px);
  }
  
  /* Submit button styles */
  .submit-button {
    width: 100%;
    padding: 8px;
    background-color: #4caf50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 600;
    margin-top: 10px;
  }
  
  .submit-button:hover {
    background-color: #45a049;
  }
  
  .components-section-title {
    font-weight: 600;
    margin-bottom: 15px;
    border-bottom: 1px solid #eee;
    padding-bottom: 8px;
  }
  
  .no-components-message {
    color: #999;
    font-style: italic;
    margin-bottom: 15px;
  }
`;

const BomMaster: React.FC = () => {
  const {
    itemOptions,
    fetchItems
  } = BomUtils();

  const [bomData, setBomData] = useState<Bom[]>([]);
  const [newBom, setNewBom] = useState({
    itemId: "",
    components: [] as Component[],

  });
  const [originalBom, setOriginalBom] = useState({
    itemId: "",
    components: [] as Component[],
  });
  const [editingBom, setEditingBom] = useState<Bom | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [validationErrors, setValidationErrors] = useState<{
    itemId?: string;
    components?: string;
    status?: string;
  }>({});

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState<number>(0);

  const [sortBy, setSortBy] = useState<string>("item");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertConfirmAction, setAlertConfirmAction] = useState<() => void>(
    () => { }
  );
  const [alertCancelAction, setAlertCancelAction] = useState<() => void>(
    () => { }
  );
  const [showConfirmButton, setShowConfirmButton] = useState(true);
  const [showCancelButton, setShowCancelButton] = useState(true);
  const [confirmButtonText, setConfirmButtonText] = useState("OK");
  const [cancelButtonText, setCancelButtonText] = useState("Cancel");
  const [autoCloseDelay, setAutoCloseDelay] = useState<number | null>(null);

  const statusOptions = [
    { value: "ACTIVE", label: "ACTIVE" },
    { value: "INACTIVE", label: "INACTIVE" },
  ];

  const dispatch = useDispatch();
  const filters = useSelector((state: RootState) => state.filters);
  const permission = useSelector((state: RootState) => state.permissions);

  const [initializeBomMaster, setIsBomMasterInitialized] = useState(false);

  useEffect(() => {
    dispatch(resetFilters());
    setIsBomMasterInitialized(true);
  }, [dispatch]);

  useEffect(() => {
    if (initializeBomMaster) {
      fetchBoms();
    }
  }, [
    initializeBomMaster,
    searchTerm,
    currentPage,
    itemsPerPage,
    filters,
    sortBy,
    sortOrder,
  ]);

  useEffect(() => {
    fetchItems("");
  }, []);

  const preventScroll = (e: WheelEvent) => {
    e.preventDefault();
  };

  const fetchBoms = async () => {
    setIsLoading(true);
    try {
      const response: any = await getData(
        "/bom",
        {
          page: currentPage,
          limit: itemsPerPage,
          search: searchTerm,
          filter: filters,
          sortBy: sortBy,
          sortOrder: sortOrder,
        }
      );

      console.log(response.data.data);


      setBomData(response.data.data);
      setTotalPages(response?.data?.pagination?.totalPages || 1);
      setTotalItems(response?.data?.pagination?.total || 0);
    } catch (error) {
      console.error("Error fetching BOMs:", error);
      configureAlert(
        "Failed to load BOM data.",
        closeAlert,
        closeAlert,
        "OK",
        "",
        true,
        false,
        3000
      );
    } finally {
      setIsLoading(false);
    }
  };

  const closeAlert = () => {
    setShowAlert(false);
  };

  const configureAlert = (
    message: string,
    confirmAction: () => void,
    cancelAction: () => void = () => { },
    confirmText: string = "OK",
    cancelText: string = "Cancel",
    showConfirm: boolean = true,
    showCancel: boolean = true,
    autoClose: number | null = null
  ) => {
    setAlertMessage(message);
    setAlertConfirmAction(() => confirmAction);
    setAlertCancelAction(() => cancelAction);
    setConfirmButtonText(confirmText);
    setCancelButtonText(cancelText);
    setShowConfirmButton(showConfirm);
    setShowCancelButton(showCancel);
    setAutoCloseDelay(autoClose);
    setShowAlert(true);
  };

  const validateForm = (): boolean => {
    const errors: {
      itemId?: string;
      components?: string;
      status?: string;
    } = {};

    if (!newBom.itemId) {
      errors.itemId = "Item is required";
    }

    if (newBom.components.length === 0) {
      errors.components = "At least one component is required";
    } else {
      const invalidComponents = newBom.components.some(
        (comp) => !comp.itemId || comp.qty <= 0
      );
      if (invalidComponents) {
        errors.components = "All components must have an valid item selected and a valid quantity";
      }
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const hasChanges = (): boolean => {
    const currentBom = JSON.stringify({
      itemId: newBom.itemId,
      components: newBom.components.map(c => ({
        itemId: c.itemId,
        qty: c.qty
      }))
    });

    const original = JSON.stringify({
      itemId: originalBom.itemId,
      components: originalBom.components.map(c => ({
        itemId: c.itemId,
        qty: c.qty
      }))
    });

    return currentBom !== original;
  };

  const handleAddOrEdit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    console.log("editing bom status:", editingBom);
    console.log("editingBom ID:", editingBom?._id);

    if (editingBom) {
      if (!hasChanges()) {
        configureAlert(
          "No changes were made.",
          closeAlert,
          closeAlert,
          "OK",
          "",
          true,
          false,
          3000
        );
        return;
      }
    }

    try {
      const formattedBom = {
        itemId: newBom.itemId,
        components: newBom.components.map(comp => ({
          itemId: comp.itemId,
          qty: comp.qty   
        })),
      };

      console.log("Formatted BOM data:", formattedBom);

      if (editingBom) {
        console.log(`Updating BOM with ID: ${editingBom._id}`);

        const response = await patchData(`/bom`, editingBom._id, formattedBom);
        console.log("Update response:", response);

        setIsModalOpen(false);

        configureAlert(
          `BOM has been updated successfully.`,
          () => {
            fetchBoms();
            closeAlert();
          },
          closeAlert,
          "OK",
          "",
          true,
          false,
          3000
        );
      } else {
        const response: any = await postData("/bom", formattedBom);
        console.log("Create response:", response);

        setIsModalOpen(false);

        if (response.statusCode === 1001) {
          configureAlert(
            `BOM has been added successfully.`,
            () => {
              fetchBoms();
              closeAlert();
            },
            closeAlert,
            "OK",
            "",
            true,
            false,
            3000
          );
        } else {
          configureAlert(
            "Failed to create BOM. Please try again.",
            closeAlert,
            closeAlert,
            "OK",
            "",
            true,
            false,
            3000
          );
        }
      }

      setEditingBom(null);
      setNewBom({
        itemId: "",
        components: [],
      });
      setOriginalBom({
        itemId: "",
        components: [],
      });
    } catch (error) {
      console.error("Error saving BOM:", error);

      configureAlert(
        "failed to addnbom",
        closeAlert,
        closeAlert,
        "OK",
        "",
        true,
        false,
        3000
      );
    }
  };

  const handleDeleteBom = async (id: string) => {
    const bomToDelete: any = bomData.find((bom) => bom._id === id);

    if (bomToDelete) {
      configureAlert(
        `Are you sure you want to Inactive "${bomToDelete.item.partName}" BOM?`,
        async () => {
          closeAlert();

          try {
            await deleteData("/bom", id);

            configureAlert(
              "BOM has been Inactive successfully.",
              () => {
                fetchBoms();
                closeAlert();
              },
              closeAlert,
              "OK",
              "",
              true,
              false,
              3000
            );
          } catch (error) {
            console.error("Error deleting BOM:", error);
            configureAlert(
              "Failed to delete BOM.",
              closeAlert,
              closeAlert,
              "OK",
              "",
              true,
              false,
              3000
            );
          }
        },
        closeAlert,
        "Yes",
        "No",
        true,
        true,
        null
      );
    }
  };

  const handleSelectChange = (selected: any, { name }: any) => {
    const selectedItemId = selected?.value || "";

    const duplicateComponent = newBom.components.find(
      (comp) => comp.itemId === selectedItemId
    );

    if (duplicateComponent) {
      setValidationErrors((prev) => ({
        ...prev,
        itemId: "Parent Item cannot be the same as any Component Part.",
      }));
      return;
    }

    setNewBom((prev) => ({
      ...prev,
      [name]: selectedItemId,
    }));

    if (validationErrors[name as keyof typeof validationErrors]) {
      setValidationErrors((prev) => ({
        ...prev,
        [name]: undefined,
      }));
    }
  };

  const handleComponentItemChange = (index: number, selected: any) => {
    const selectedItemId = selected?.value || "";

    if (selectedItemId === newBom.itemId) {
      setValidationErrors((prev) => ({
        ...prev,
        components: `Child Part cannot be same as Parent Item.`,
      }));
      return;
    }

    const updatedComponents = [...newBom.components];
    updatedComponents[index] = {
      ...updatedComponents[index],
      itemId: selectedItemId,
      itemName: selected?.label || "",
    };

    setNewBom((prev) => ({
      ...prev,
      components: updatedComponents,
    }));

    if (validationErrors.components) {
      setValidationErrors((prev) => ({
        ...prev,
        components: undefined,
      }));
    }
  };

  const handleComponentQtyChange = (index: number, value: string) => {
    const qty = parseFloat(value);
    const updatedComponents = [...newBom.components];
    updatedComponents[index] = {
      ...updatedComponents[index],
      qty: isNaN(qty) ? 0 : qty,
    };

    setNewBom((prev) => ({
      ...prev,
      components: updatedComponents,
    }));

    if (validationErrors.components) {
      setValidationErrors((prev) => ({
        ...prev,
        components: undefined,
      }));
    }
  };

  const addNewComponent = () => {
    setNewBom((prev) => ({
      ...prev,
      components: [...prev.components, { itemId: "", qty: 1 }],
    }));
  };

  const removeComponent = (index: number) => {
    const updatedComponents = [...newBom.components];
    updatedComponents.splice(index, 1);

    setNewBom((prev) => ({
      ...prev,
      components: updatedComponents,
    }));
  };

  const handleModalClose = () => {
    if (isModalOpen && hasChanges()) {
      configureAlert(
        "Are you sure you want to close without saving?",
        () => {
          setIsModalOpen(false);
          setEditingBom(null);
          setNewBom({
            itemId: "",
            components: [],
          });
          setOriginalBom({
            itemId: "",
            components: [],
          });
          closeAlert();
        },
        closeAlert,
        "Yes",
        "No",
        true,
        true,
        null
      );
    } else {
      setIsModalOpen(false);
      setEditingBom(null);
      setNewBom({
        itemId: "",
        components: [],
      });
      setOriginalBom({
        itemId: "",
        components: [],
      });
    }
  };

  const handleEditBom = (bom: Bom) => {
    try {
      const bomToEdit = bomData.find(b => b._id === bom._id);

      if (!bomToEdit) {
        throw new Error("BOM not found in the current data");
      }

      const formattedBom = {
        itemId: bomToEdit.item._id,
        components: bomToEdit.components.map((comp: any) => ({
          itemId: comp.item._id,
          qty: comp.qty,
          itemName: comp.itemId.itemName || "Unknown Item"
        })),
      };

      setNewBom(formattedBom);
      setOriginalBom(JSON.parse(JSON.stringify(formattedBom)));
      setEditingBom(bomToEdit);
      setValidationErrors({});
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error preparing BOM data for editing:", error);
      configureAlert(
        "Failed to load BOM details for editing.",
        closeAlert,
        closeAlert,
        "OK",
        "",
        true,
        false,
        3000
      );
    }
  };

  const handleSortChange = (
    sortByField: string,
    sortOrderDirection: "asc" | "desc"
  ) => {
    setSortBy(sortByField);
    setSortOrder(sortOrderDirection);
  };

  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [selectedBomId, setSelectedBomid] = useState<string>("");
  const [parentComponent, setParentComponent] = useState<any>({})

  const handleBomClick = (rowData: any) => {
    console.log(rowData.item);

    setSelectedBomid(rowData._id);
    setIsPopupOpen(true);
    setParentComponent(rowData.item)
  };

  const columns = [
    {
      key: 'item',
      nameKey: "hsnCode",
      label: "HSN Code",
      sortable: true,
      render: (value: any) => value && typeof value === "object" ? value.hsnCode || "N/A" : "N/A",
    },
    {
      key: 'item',
      nameKey: "partName",
      label: "Part Name",
      sortable: true,
      render: (value: any) => value && typeof value === "object" ? value.partName || "N/A" : "N/A",
    },
    {
      key: 'item',
      nameKey: "internalPartNo",
      label: "Internal Part No",
      sortable: true,
      render: (value: any) => value && typeof value === "object" ? value.internalPartNo || "N/A" : "N/A",
    },
    {
      key: 'item',
      nameKey: "externalPartNo",
      label: "External Part No",
      sortable: true,
      render: (value: any) => value && typeof value === "object" ? value.externalPartNo || "N/A" : "N/A",
    },
    {
      key: "item",
      label: "Model",
      nameKey: "model.name",
      render: (value: any) => value && typeof value === "object" ? value.model.name || "N/A" : "N/A",
      sortable: true,
    },
    {
      key: "item",
      label: "Category",
      nameKey: "category.name",
      render: (value: any) => value && typeof value === "object" ? value.category.name || "N/A" : "N/A",
      sortable: true,
    },
    {
      key: "item",
      label: "UOM",
      nameKey: "uom.name",
      render: (value: any) => value && typeof value === "object" ? value.uom.name || "N/A" : "N/A",
      sortable: true,
    },
  ];

  return (
    <div className="item-models-container">
      <style>{customStyles}</style>

      <div className="item-models-header">
        <div className="border">
          <div className="start-end-layout">
            <div className="breadcrumb-nav">
              <span>Inventory</span>
              <span>BOM Master</span>
            </div>
            {permission.menus.bom?.create !== false && (
              <div
                className="items-button-container tooltip-wrapper"
                onClick={() => {
                  setNewBom({
                    itemId: "",
                    components: [],
                  });
                  setOriginalBom({
                    itemId: "",
                    components: [],
                  });
                  setEditingBom(null);
                  setValidationErrors({});
                  setIsModalOpen(true);
                }}
              >
                <button className="item-models-add-btn">
                  <Plus size={16} />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="box-container">
        {isLoading ? (
          <div className="spinner"></div>
        ) : (
          <TableComponent
            columns={columns}
            data={bomData}
            onEdit={(bom: Bom) => handleEditBom(bom)}
            onDelete={(id: string) => handleDeleteBom(id)}
            onRowClick={(rowData: any) => handleBomClick(rowData)}
            setFilter={(filters: Record<string, any>) => {
              Object.entries(filters).forEach(([key, value]) => {
                dispatch(updateFilters({ key, value: String(value) }));
              });
            }}
            setSorting={handleSortChange}
            defaultSortConfig={{ key: sortBy, direction: sortOrder }}
            context="bomMaster"
          />
        )}

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          totalItems={totalItems}
        />

        <BomComponentsPopup
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          bomId={selectedBomId}
          parentItem={parentComponent}
        />
      </div>

      {isModalOpen && (
        <div className="item-models-modal-overlay">
          <div className="item-models-modal">
            <div className="item-models-modal-header">
              <h5>{editingBom ? "Edit BOM" : "Add New BOM"}</h5>
              <button
                className="item-models-modal-close"
                onClick={handleModalClose}
              >
                <X size={18} />
              </button>
            </div>
            <div className="modal-form-container">
              <form onSubmit={handleAddOrEdit} noValidate>
                <div className="select-container">
                  <Select
                    name="itemId"
                    options={itemOptions}
                    value={itemOptions.find(
                      (item) => item.value === newBom.itemId
                    )}
                    onChange={(selected, action) =>
                      handleSelectChange(selected, action)
                    }
                    onInputChange={(inputValue) => {
                      fetchItems(inputValue)
                    }}
                    placeholder="Select Parent Item"
                    isSearchable
                    className={validationErrors.itemId ? "select-error" : ""}
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                  {validationErrors.itemId && (
                    <div className="form-error-message">
                      {validationErrors.itemId}
                    </div>
                  )}
                </div>

                <div className="components-container">
                  <h6 className="components-section-title">Child Parts</h6>

                  {validationErrors.components && (
                    <div className="form-error-message" style={{ position: "static", marginBottom: "10px" }}>
                      {validationErrors.components}
                    </div>
                  )}

                  {newBom.components.length === 0 ? (
                    <div className="no-components-message">
                      No Parts added yet. Click the "Add Part" button below.
                    </div>
                  ) : (
                    newBom.components.map((component, index) => {
                      const selectedItem = itemOptions.find((item) => item.value === component.itemId);

                      return (
                        <div key={index} className="component-row">
                          <div className="component-select">
                            <Select
                              options={itemOptions}
                              value={selectedItem}
                              onChange={(selected) =>
                                handleComponentItemChange(index, selected)
                              }
                              onInputChange={(inputValue) => {
                                fetchItems(inputValue)
                              }}
                              placeholder="Select Part"
                              isSearchable
                              classNamePrefix="react-select"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              }}
                            />
                            {validationErrors.components && (
                              <div className="form-error-message">{validationErrors.components}</div>
                            )}
                          </div>
                          <div className="qty-input">
                            <input
                              type="number"
                              value={component.qty || ""}
                              onChange={(e) =>
                                handleComponentQtyChange(index, e.target.value)
                              }
                              onFocus={(e) => {
                                e.target.addEventListener('wheel', preventScroll, { passive: false });
                              }}
                              placeholder="Qty"
                            />
                          </div>

                          <div className="qty-input">
                            <input
                              type="text"
                              value={selectedItem?.uom || ''}
                              placeholder="UOM"
                              readOnly
                            />
                          </div>

                          <button
                            type="button"
                            className="remove-btn"
                            onClick={() => removeComponent(index)}
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      );
                    })

                  )}

                  <button
                    type="button"
                    className="add-component-btn"
                    onClick={addNewComponent}
                  >
                    <Plus size={16} /> Add Part
                  </button>
                </div>
                <button type="submit" className="submit-button">
                  {isLoading ? "Saving..." : editingBom ? "Update" : "Add"}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {showAlert && (
        <CustomAlert
          message={alertMessage}
          onConfirm={alertConfirmAction}
          onCancel={alertCancelAction}
          confirmText={confirmButtonText}
          cancelText={cancelButtonText}
          showConfirmButton={showConfirmButton}
          showCancelButton={showCancelButton}
          autoCloseDelay={autoCloseDelay}
        />
      )}
    </div>
  );
};

export default BomMaster;